export const dashboardKeys = {
  all: ["dashboard"] as const,
  creditBalance: (userId: string) =>
    [...dashboardKeys.all, "credit-balance", userId] as const,
  paidCreditBalance: (userId: string) =>
    [...dashboardKeys.all, "paid-credit-balance", userId] as const,
  orders: (userId: string) =>
    [...dashboardKeys.all, "report-orders", userId] as const,
  orderHistory: (userId: string) =>
    [...dashboardKeys.orders(userId), "history"] as const,
  orderStats: (userId: string) =>
    [...dashboardKeys.orders(userId), "stats"] as const,
  activeOrders: (userId: string) =>
    [...dashboardKeys.orders(userId), "active"] as const,
  transactions: (userId: string) =>
    [...dashboardKeys.all, "credit-transactions", userId] as const,
  generationJobs: (userId: string, orderIds: string[]) =>
    [...dashboardKeys.all, "generation-jobs", userId, orderIds.join(",")] as const,
  reportDetail: (userId: string, orderId: string) =>
    [...dashboardKeys.all, "report-detail", userId, orderId] as const,
};
